import { AttachmentSection } from "@domain/lms/course/courseSection";
import { SectionController } from "@ui/pages/lms/courseEditorPage/courseEditorController/sectionController";

export class AttachmentSectionController extends SectionController<AttachmentSection> {
	setTitle(title: string): void {
		this.sectionUpdater((current) => ({ ...current, title }));
	}
}
